import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { ReactComponent as RedxIcon } from '../../../assets/icons/redX.svg';
import './EditBasketNameModal.scss';
import { Button, EButtonType, Input } from '@repo/apg-ui';

interface Props {
  basketId: string;
  basketreference: string;
  initName: string;
  onClose: any;
  onSuccess: any;
  updateBasketName: any;
}

const EditBasketNameModal = ({ onClose, updateBasketName, basketId, basketreference, onSuccess, initName }: Props) => {
  const [name, setName] = React.useState(initName);
  const intl = useIntl();

  return (
    <div className='edit-basket-name-modal' id='root'>
      <div className='close-modal'>
        <Button onClick={onClose}>
          <FormattedMessage id='ec.confirmation.close' defaultMessage='Schliessen' />
          <RedxIcon />
        </Button>
      </div>
      <div className={'row my-4'}>
        <Input
          value={name}
          name={'name'}
          onChange={(name, value) => setName(value)}
          type='text'
          placeholder={intl.formatMessage({
            id: 'ec.confirmation.table.basket.name.placeholder',
            defaultMessage: 'Name der Warenkorbname',
          })}
          inputWrapperClass='high col-12'
        >
          {intl.formatMessage({
            id: 'ec.confirmation.table.basket.name',
            defaultMessage: 'Sujet/Warenkorbname',
          })}
        </Input>
      </div>
      <div className={'my-4 d-flex justify-content-end'}>
        <Button
          className='w-100'
          onClick={() => {
            updateBasketName({
              basket: basketId,
              basketreference: basketreference,
              name: name,
            }).then(() => {
              onSuccess(basketId, basketreference, name);
              onClose();
            });
          }}
          buttonType={EButtonType.PillMedium}
        >
          <FormattedMessage id='ec.confirmation.save' defaultMessage='Speichern' />
        </Button>
      </div>
    </div>
  );
};

export default EditBasketNameModal;
